import { AxiosError } from 'axios';
import { createAsyncAction } from 'typesafe-actions';
import { BidChance, BidChanceParams, BidProposalParams } from './types';

export const GET_BID_CHANCE_LIST = 'bidChances/GET_BID_CHANCE_LIST';
export const GET_BID_CHANCE_LIST_SUCCESS =
  'bidChances/GET_BID_CHANCE_LIST_SUCCESS';
export const GET_BID_CHANCE_LIST_ERROR = 'bidChances/GET_BID_CHANCE_LIST_ERROR';

// export const CREATE_BID_CHANCE = 'bidChances/CREATE_BID_CHANCE';
// export const CREATE_BID_CHANCE_SUCCESS = 'bidChances/CREATE_BID_CHANCE_SUCCESS';
// export const CREATE_BID_CHANCE_ERROR = 'bidChances/CREATE_BID_CHANCE_ERROR';

export const UPDATE_BID_CHANCE = 'bidChances/UPDATE_BID_CHANCE';
export const UPDATE_BID_CHANCE_SUCCESS = 'bidChances/UPDATE_BID_CHANCE_SUCCESS';
export const UPDATE_BID_CHANCE_ERROR = 'bidChances/UPDATE_BID_CHANCE_ERROR';

// export const DELETE_BID_CHANCE = 'bidChances/DELETE_BID_CHANCE';
// export const DELETE_BID_CHANCE_SUCCESS = 'bidChances/DELETE_BID_CHANCE_SUCCESS';
// export const DELETE_BID_CHANCE_ERROR = 'bidChances/DELETE_BID_CHANCE_ERROR';

export const GET_BID_CHANCE_DETAIL = 'bidChances/GET_BID_CHANCE_DETAIL';
export const GET_BID_CHANCE_DETAIL_SUCCESS =
  'bidChances/GET_BID_CHANCE_DETAIL_SUCCESS';
export const GET_BID_CHANCE_DETAIL_ERROR =
  'bidChances/GET_BID_CHANCE_DETAIL_ERROR';

export const CREATE_BID_PROPOSAL = 'bidChances/CREATE_BID_PROPOSAL';
export const CREATE_BID_PROPOSAL_SUCCESS =
  'bidChances/CREATE_BID_PROPOSAL_SUCCESS';
export const CREATE_BID_PROPOSAL_ERROR = 'bidChances/CREATE_BID_PROPOSAL_ERROR';

export const GET_BID_CHANCE_DETAIL2 = 'bidChances/GET_BID_CHANCE_DETAIL2';
export const GET_BID_CHANCE_DETAIL2_SUCCESS =
  'bidChances/GET_BID_CHANCE_DETAIL2_SUCCESS';
export const GET_BID_CHANCE_DETAIL2_ERROR =
  'bidChances/GET_BID_CHANCE_DETAIL2_ERROR';

export const getBidChanceListAsync = createAsyncAction(
  GET_BID_CHANCE_LIST,
  GET_BID_CHANCE_LIST_SUCCESS,
  GET_BID_CHANCE_LIST_ERROR,
)<BidChanceParams, BidChance[], AxiosError>();

// export const createBidChanceAsync = createAsyncAction(
//   CREATE_BID_CHANCE,
//   CREATE_BID_CHANCE_SUCCESS,
//   CREATE_BID_CHANCE_ERROR,
// )<BidChance, BidChance, AxiosError>();

export const updateBidChanceAsync = createAsyncAction(
  UPDATE_BID_CHANCE,
  UPDATE_BID_CHANCE_SUCCESS,
  UPDATE_BID_CHANCE_ERROR,
)<BidChanceParams, BidChance, AxiosError>();

// export const deleteBidChanceAsync = createAsyncAction(
//   DELETE_BID_CHANCE,
//   DELETE_BID_CHANCE_SUCCESS,
//   DELETE_BID_CHANCE_ERROR,
// )<BidChance, number, AxiosError>();

export const getBidChanceDetailAsync = createAsyncAction(
  GET_BID_CHANCE_DETAIL,
  GET_BID_CHANCE_DETAIL_SUCCESS,
  GET_BID_CHANCE_DETAIL_ERROR,
)<BidChanceParams, BidChance, AxiosError>();

export const createBidProposalAsync = createAsyncAction(
  CREATE_BID_PROPOSAL,
  CREATE_BID_PROPOSAL_SUCCESS,
  CREATE_BID_PROPOSAL_ERROR,
)<BidProposalParams, BidChance, AxiosError>();

export const getBidChanceDetail2Async = createAsyncAction(
  GET_BID_CHANCE_DETAIL2,
  GET_BID_CHANCE_DETAIL2_SUCCESS,
  GET_BID_CHANCE_DETAIL2_ERROR,
)<BidChanceParams, BidChance, AxiosError>();
